import type {
  BatchStatus,
  RollbackScope,
  SettlementDateAdjustmentSource,
  SettlementItemPeriodType,
  SettlementItemStatus,
  SettlementItemType,
} from '../../../lib/api/settlementDateAdjustment';

/**
 * 정산아이템/배치의 영문 enum 값을 화면 표시용 한국어로 매핑.
 * 백엔드의 SETTLEMENT_ITEM_*_SWAGGER_MAP과 맞추고, 기존 정산 페이지 컨벤션
 * (구분/상태 컬럼 등)을 따른다.
 */
export const SETTLEMENT_ITEM_TYPE_LABEL: Record<SettlementItemType, string> = {
  order: '상품 주문',
  extraDelivery: '추가 배송비',
  returnDelivery: '반품 배송비',
};

export const SETTLEMENT_ITEM_STATUS_LABEL: Record<SettlementItemStatus, string> = {
  // 기존 '정산 대기목록' 페이지 등 ready를 '정산 대기'로 표기하는 컨벤션 유지
  ready: '정산 대기',
  completed: '정산 완료',
  hold: '정산 보류',
};

export const SETTLEMENT_ITEM_PERIOD_TYPE_LABEL: Record<
  SettlementItemPeriodType,
  string
> = {
  daily: '일정산',
  monthly: '월정산',
};

export const SETTLEMENT_DATE_ADJUSTMENT_BATCH_STATUS_LABEL: Record<BatchStatus, string> = {
  pending: '실행 대기',
  executed: '실행 완료',
  partiallyRolledBack: '부분 롤백',
  fullyRolledBack: '전체 롤백',
  failed: '실패',
};

/**
 * 관리처 코드(productManagementType.management) → 한국어 라벨.
 * 기존 SettlementList의 SettlementManagement 타입 ('브랜드' | '아몬즈')과 동일 의미.
 */
export const SETTLEMENT_MANAGEMENT_LABEL: Record<number, string> = {
  0: '브랜드',
  1: '아몬즈',
};

/**
 * 롤백 대상 범위(scope) → 한국어 라벨. 사용자 확인 모달 등 UI 노출용.
 */
export const ROLLBACK_SCOPE_LABEL: Record<RollbackScope, string> = {
  all: '활성 전체',
  byIds: '선택한 정산 ID',
  byStoreId: '특정 브랜드',
  byOrderItemIds: '특정 상품 주문',
};

/**
 * Preview 응답의 excluded.reason → 사용자 노출용 한국어 라벨.
 * 백엔드 settlement-date-adjustments.service.ts의 preview() 함수에서 push하는 값.
 */
export const PREVIEW_EXCLUDED_REASON_LABEL: Record<string, string> = {
  completed: '정산 완료 상태',
  notFound: '존재하지 않음',
  extraDelivery: '추가 배송비 (스케줄러 중복 생성 위험)',
  returnDelivery: '반품 배송비 (스케줄러 중복 생성 위험)',
};

/**
 * UI 선정 방식(source) → 한국어 라벨. 이력 리스트/상세 표시 + 버그 트래킹 시
 * "테이블 체크로 고른 건지, 엑셀 업로드인지" 재현 경로 파악용.
 */
export const SETTLEMENT_DATE_ADJUSTMENT_SOURCE_LABEL: Record<
  SettlementDateAdjustmentSource,
  string
> = {
  tableSelection: '테이블 선택',
  excelUpload: '엑셀 업로드',
};
